import { NgClass } from '@angular/common';
import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { WdxIconModule } from '@wdx/shared/components/wdx-icon';
import {
    DEFAULT_INPUT_DEBOUNCE_DELAY,
    TranslateTokenisedStringPipe,
    TRANSLATION_SEARCH_PLACEHOLDER,
    WdxDestroyClass,
} from '@wdx/shared/utils';
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'wdx-search-input',
    templateUrl: './wdx-search-input.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        WdxIconModule,
        FormsModule,
        TranslateTokenisedStringPipe,
        NgClass,
    ],
})
export class WdxSearchInputComponent
    extends WdxDestroyClass
    implements OnInit, AfterViewInit
{
    @Input() autoFocus = false;

    @Input() placeholder = TRANSLATION_SEARCH_PLACEHOLDER;

    @Input() debounceTimeMs = DEFAULT_INPUT_DEBOUNCE_DELAY;

    @Input() set resetSearch(timestamp: number) {
        if (timestamp) {
            this.value = '';
            this.searchText$.next({ searchTerm: '', disableEmit: true });
        }
    }

    @Input() inputGroupClasses = '';

    @Output() wdxChanged = new EventEmitter<string>();

    @ViewChild('searchInput') searchInput!: ElementRef;

    private searchText$ = new Subject<{
        searchTerm: string;
        disableEmit?: boolean;
    }>();

    public value = '';

    search(searchTerm: string) {
        this.searchText$.next({ searchTerm });
    }

    ngOnInit() {
        this.searchText$
            .pipe(
                debounceTime(this.debounceTimeMs),
                distinctUntilChanged(),
                takeUntil(this.destroyed$),
            )
            .subscribe(({ searchTerm, disableEmit }) => {
                if (!disableEmit) {
                    this.wdxChanged.emit(searchTerm);
                }
            });
    }

    ngAfterViewInit(): void {
        if (this.autoFocus) {
            this.searchInput?.nativeElement?.focus();
        }
    }
}
